import createUserSlice from "./user";
import { UserSlice } from "./user.types";

export type { UserSlice };
export default createUserSlice;
